/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WebsiteTemplateRegistryUploadStatus {
    UPLOADING = 'uploading',
    VALIDATING = 'validating',
    READY = 'ready',
    FAILED = 'failed',
}
